// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
/**
 * @packageDocumentation
 * @module terminal
 */
export * from './tokens';
export * from './widget';
//# sourceMappingURL=index.js.map